import classNames from 'classnames';

import ErrorText from '../ErrorText';
import { MAX_NAME_LENGTH } from '../../helpers/validations';

import styles from './_index.module.scss';

export interface EditableTitleProps {
  autoFocus?: boolean;
  className?: string;
  error?: string;
  isDisabled?: boolean;
  onBlur?: (value: string) => void;
  onChange: (value: string) => void;
  value?: string;
}

const EditableTitle = ({
  autoFocus,
  className,
  error,
  isDisabled,
  onBlur = () => {},
  onChange,
  value = '',
}: EditableTitleProps) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const targetElement = event.target as HTMLInputElement;
    if (event?.key === 'Enter') {
      onChange(targetElement.value);
      targetElement.blur();
    }
  };

  return (
    <div
      className={classNames(styles['editable-title'], className, {
        [styles['has-error']]: error,
        [styles['is-disabled']]: isDisabled,
      })}
    >
      <div className={styles['editable-title-input-wrapper']}>
        <h1>{value}</h1>
        <input
          aria-label="editable-title"
          autoFocus={autoFocus}
          className={classNames({ [styles['has-error']]: error })}
          data-testid="editable-title"
          disabled={isDisabled}
          maxLength={MAX_NAME_LENGTH}
          onBlur={(event) => onBlur(event.target.value)}
          onChange={(event) => onChange(event.target.value)}
          onFocus={(event) => event.target.select()}
          onKeyDown={(event) => onKeyDown(event)}
          type="text"
          value={value}
        />
      </div>
      {error && <ErrorText className={styles['editable-title-error']}>{error}</ErrorText>}
    </div>
  );
};

export default EditableTitle;
